import React from "react";
import AttributeDefinition from "../../domain/AttributeDefinition";
import VulSourceItem from "../../domain/VulSourceItem";
import AiAttributeEntriesBlock from "./AiAttributeEntriesBlock";
import SealScore from "./SealScore";
import SourceTag from "./SourceTag";
import VulSourceItemDescription from "./VulSourceItemDescription";
import * as styles from "./VulSourceItemPreview.module.css";

interface Props {
    item: VulSourceItem;
    attributeDefinitions?: AttributeDefinition[];
    showAiAnalytics?: boolean;
    showTitle?: boolean;
    showAffected?: boolean;
    framed?: boolean;
    metadataExtra?: React.ReactNode;
}

function VulSourceItemPreview({
    item,
    attributeDefinitions,
    showAiAnalytics,
    showTitle,
    showAffected,
    framed,
    metadataExtra
}: Props) {
    return <>
        <div className={styles.description}>
            <SourceTag source={item.source}/>

            <SealScore item={item}/>

            {metadataExtra}
        </div>

        {(showAiAnalytics ?? true) && (
            <AiAttributeEntriesBlock
                item={item}
                aiAttributeTagClassName={styles["ai-attribute-tag"]}
                aiAttributeTagInteractiveClassName={styles["ai-attribute-tag-interactive"]}
            />
        )}

        <VulSourceItemDescription
            sourceType={item.source.sourceType}
            attributes={item.attributes}
            affected={item.affected}
            showTitle={showTitle}
            showAffected={showAffected}
            attributeDefinitions={attributeDefinitions}
            hideSealScoreTag={true}
            framed={framed}
        />
    </>;
}

export default VulSourceItemPreview;
